export default __webpack_public_path__ + "static/media/sun-filled.df239ad9.svg";